module.exports = __webpack_public_path__ + "static/Multi-Column-Grouping-e12879e75bbe3f63b0a9a23e1064fe02.png";